import React from "react"
import RecipeInstructions from "./RecipeInstructions"
import HeroDiet from "./HeroDiet"
import SimilarRecipes from "./SimilarRecipes"



const DietDetails = () => {
    return (

        <React.Fragment>
            <div > <HeroDiet /></div>
            <div>  <RecipeInstructions /></div>

          
            <SimilarRecipes />
        </React.Fragment>
    )
}

export default DietDetails